import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState } from 'react';
import AlertsActions from './alertsActions';
import AlertsTable from './alertsTable';

var AlertsList = function AlertsList() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedAlert = _useState2[0],
      onAlertsSelect = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlertsActions, {
    selectedAlert: selectedAlert
  }), /*#__PURE__*/React.createElement(AlertsTable, {
    onAlertsSelect: onAlertsSelect
  }));
};

export default AlertsList;